import React from 'react'
import { Box, Paper, styled } from '@mui/material'
import logo from '../../img/logo_powerspace.svg'

export const chevronSize = '1rem'

export const loginPalette = {
  chevron: '#E52B7A',
  background: '#1d2d3d',
}

export const StyledMain = styled('main')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
  backgroundColor: loginPalette.background,
  padding: '2rem 5rem',

  '@media (max-width: 600px)': {
    padding: '2rem 1rem',
  },
})

export const Chevron = styled(Box)({
  position: 'absolute',
  height: '4rem',
  width: '4rem',
})

export const PaperPaperStyle = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '42rem',
  padding: theme.spacing(5),

  '& > h1': {
    marginTop: 0,
  },
}))

export const DivLogo = styled('div')({
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '2rem',

  '& img': {
    width: '22rem',
  },
})

export const PCopyright = styled('p')(() => ({
  color: '#C4C4C4',
  fontSize: '1.2rem',
  textAlign: 'center',
  marginTop: '2rem',
  left: 0,
  right: 0,
}))

export const DivBottomLink = styled('div')({
  marginTop: 'auto',
  fontSize: '1.3rem',
})

const LoggedOutLayoutWrapper: React.FC = ({ children }) => {
  return (
    <StyledMain>
      <DivLogo>
        <img src={logo} alt="Powerspace" />
      </DivLogo>
      <PaperPaperStyle>{children}</PaperPaperStyle>
      <PCopyright>Copyright &copy; {new Date().getFullYear()} Powerspace</PCopyright>
    </StyledMain>
  )
}

export default LoggedOutLayoutWrapper
